/* Native <details> works without JavaScript; this adds keyboard/outside closing. */
(() => {
  const closeMenus = (restoreFocus = false) => {
    document.querySelectorAll('.pt-menu[open]').forEach(menu => {
      menu.open = false;
      if (restoreFocus) menu.querySelector('summary')?.focus();
    });
  };
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') closeMenus(true);
  });
  document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    if (event.target.closest('.pt-menu__panel a') || !event.target.closest('.pt-menu')) closeMenus();
  });
  document.addEventListener('shopify:block:select', event => {
    const question = event.target.closest?.('.pt-question');
    if (question) question.open = true;
  });
})();
